var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 9.29295C5.68342 8.90243 6.31658 8.90243 6.70711 9.29295L12 14.5858L17.2929 9.29295C17.6834 8.90243 18.3166 8.90243 18.7071 9.29295C19.0976 9.68348 19.0976 10.3166 18.7071 10.7072L12.7071 16.7072C12.3166 17.0977 11.6834 17.0977 11.2929 16.7072L5.29289 10.7072C4.90237 10.3166 4.90237 9.68348 5.29289 9.29295Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a86fd4c60c0327a7bb7a78a1adc5b073.svg";
export { ForwardRef as ReactComponent };